<template>
  <div
    class="bill bill_text_color--text"
    :style="{ backgroundImage: branch_watermark }"
  >
    <div
      class="di-flex justify-space-between mb-2 row-reversable"
      style="flex: 1; align-items: center; font-size: 14px"
    >
      <img
        alt="SO"
        class="bill_logo"
        :src="branch_logo"
        style="width: 2cm; height: auto"
      />
      <div class="text-xs-center">
        <div class="font-weight-bold bill_title">{{ branch_fa_name }}</div>
        <div class="font-weight-bold bill_title">{{ LONG_APP_NAME }}</div>
        <div class="font-weight-bold bill_title">
          {{ $t("cash_receipt_title") }}
        </div>
      </div>
      <!-- <img
        alt="SO"
        class="bill_logo"
        :src="APP_LOGO"
        style="width: 2cm; height: auto"
      /> -->
      <div style="width: 2cm; height: auto"></div>
    </div>
    <v-divider></v-divider>
    <div class="di-flex justify-space-between mt-2">
      <span>
        <strong>{{ $t("credit_number") }}: </strong>
        {{ credit.number || (system && system.last_form_number + 1) }}
      </span>
      <span
        ><strong>{{ $t("time") }}: </strong>
        {{ credit.time }}
      </span>
    </div>
    <div class="di-flex justify-space-between">
      <span>
        <strong>{{ $t("reg_no") }}: </strong>
        {{ customer && customer.id }}
      </span>
      <span>
        <strong>{{ $t("date") }}: </strong>
        {{ credit.date | persianDateFilter }}
      </span>
    </div>
    <div class="di-flex justify-space-between mb-2">
      <span>
        <strong>{{ $t("customer") }}: </strong>
        {{ customer && customer.name }}
      </span>
      <span>
        <strong>{{ $t("persian_date") }}: </strong>
        {{ credit.date | persianDateFilter(true) }}
      </span>
    </div>
    <table class="greyGridTable bill-table mb-5">
      <tbody class="text-xs-center">
        <tr>
          <td
            class="bill_color white--text"
            style="font-size: 14px; font-weight: 700"
          >
            <span>
              {{ $t("id") }}
            </span>
          </td>
           <td
            class="bill_color white--text"
            style="font-size: 14px; font-weight: 700"
          >
            <span>
              {{ $t("amount") }}
            </span>
          </td>
          <td
            class="bill_color white--text"
            style="font-size: 14px; font-weight: 700"
          >
            <span>
              {{ $t("currency") }}
            </span>
          </td>
          <td
            class="bill_color white--text"
            style="font-size: 14px; font-weight: 700"
          >
            <span>
              {{ $t("amount_in_word") }}
            </span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="mx-2 pcf-text">
              {{ credit.id }}
            </span>
          </td>
          <td>
            <span class="mx-2 pcf-text">
              {{ credit.amount | currency }}
            </span>
          </td>
          <td>
            <span class="mx-2 pcf-text">
              {{ smbl(credit.currency_id, true) }}
            </span>
          </td>
          <td>
            <span class="mx-2 pcf-text">
              {{ credit.amount | toWord }}   {{ smbl(credit.currency_id, true) }}
            </span>
          </td>
        </tr>
        <tr>
          <td class="lr--text" colspan="100%">
            <span class="pcf-label">{{ $t("description") }}: </span>
            <span class="pcf-text mx-2">{{ credit.description }}</span>
          </td>
        </tr>
        <tr>
          <td class="lr--text" colspan="100%">
            <span class="pcf-label">{{ $t("payment_type") }}: </span>
            <span class="pcf-text mx-2">{{
              credit.receiver ? credit.receiver.name : ""
            }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <bill-footer :userProp="credit.user"></bill-footer>
  </div>
</template>
<script>
export default {
  name: "bill-credit",
  props: {
    credit: { default: () => {} },
    customer: { default: () => {} },
    system: { default: () => {} },
  },
};
</script>